import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
    /* Breadcrumb */
    .breadcrumb {
        display: flex;
        flex-wrap: wrap;
        padding: 0.75rem 1rem;
        margin-bottom: 1rem;
        list-style: none;
        background-color: #F6F9FF;
        border-radius: 0.25rem;
    }

    .breadcrumb a {
        color: #666666;
    }

    /* Mobile Menu */
    .mobile-menu-area {
        @media (max-width: 767px) {
            display: block !important;
            background: #182B49 !important;
        }
    }

    /* Product Details */
    .product-details-page {
        background: ${colors.bg2};
        padding: 35px 0 70px;
    }

    .product-slider {
        .zoom-container {
            position: relative;
            display: inline-block;
            width: 100%;
            overflow: hidden;
            background-color: white;
        }

        .zoom-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            color: white;
            border: none;
            border-radius: 50%;
            padding: 10px;
            font-size: 20px;
            cursor: pointer;
            z-index: 2;
        }

        .zoom-btn:hover {
            background-color: rgba(0, 0, 0, 0.7);
        }

        .img-fluid {
            max-width: 100%;
            transition: transform 0.3s ease;
            transform-origin: center center;
        }

        .img-fluid:hover {
            transform: scale(1.3);
        }
    }

    /* Product Information */
    .product-information {
        margin-top: 15px;

        .product-title h4 {
            color: ${colors.black1};
            font-weight: 600;
            margin-bottom: 12px;
            font-size: 20px;

            @media (max-width: 575px) {
                font-size: 18px;
            }
        }

        .product-stock p {
            font-size: 14px;
            color: ${colors.text2};

            span.stock {
                color: ${colors.green};
                font-weight: 500;
            }
        }
    }

    /* Product Tab */
    .product-tab {
        margin-top: 40px;

        .nav {
            display: inline-block;
            border-radius: 5px;
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
            margin-bottom: 35px;

            .nav-item {
                display: inline-block;

                a.nav-link {
                    font-size: 14px;
                    color: ${colors.black2};
                    font-weight: 500;
                    padding: 12px 30px 10px;
                    border-radius: 5px;
                }

                a.nav-link.active {
                    background: ${colors.gr_bg};
                    color: #ffffff;
                }
            }
        }

        .tab-content .additional-tab table.table.table-bordered {
            margin-bottom: 0;
            border: 1px solid ${colors.border1};
        }

        .additional-tab td {
            border: 1px solid ${colors.border1};
            font-size: 14px;
            color: ${colors.text3};
            padding: 12px 18px;
        }

        .additional-tab td:first-child {
            color: ${colors.black1};
        }
    }

    /* Modal */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.75);
        z-index: 1050;
    }

    .modal-image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 400px;
        overflow: hidden;
    }

    /* Mobile Styles */
    @media (max-width: 767px) {
        .product-details-page {
            padding: 35px 0 30px;
        }

        .product-information .product-title h4 {
            font-size: 20px;
        }

        .breadcrumb {
            padding: 0.5rem 1rem;
        }

        .zoom-btn {
            font-size: 18px;
            padding: 8px;
        }

        .modal-image-container {
            height: 300px;
        }
    }
`;